import { useState as e, useEffect as t } from "react";

var _n = function n() {
  return (_n = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var l in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    o = {
  position: {
    client: {
      x: null,
      y: null
    },
    screen: {
      x: null,
      y: null
    },
    page: {
      x: null,
      y: null
    }
  },
  buttons: {
    left: null,
    middle: null,
    right: null,
    wheelDown: null,
    wheelUp: null
  },
  keyboard: {
    ctrl: null,
    shift: null,
    alt: null
  },
  eventType: null,
  selectedElement: {
    position: {
      x: null,
      y: null,
      angle: null
    },
    boundingRect: {
      left: null,
      top: null,
      width: null,
      height: null
    },
    isHover: !1
  }
};

export default function (l, r, u) {
  void 0 === l && (l = !0), void 0 === r && (r = null), void 0 === u && (u = {
    x: 0,
    y: 0
  });

  var i = e(o),
      d = i[0],
      s = i[1],
      c = null,
      a = function a(e) {
    var t,
        o,
        l,
        r,
        i,
        a,
        v = _n({}, d.buttons);

    switch (e.type) {
      case "mousemove":
      case "mousedown":
      case "mouseup":
      case "wheel":
        var m = e;
        t = m.clientX, o = m.clientY, l = m.screenX, r = m.screenY, i = m.pageX, a = m.pageY, v.left = [1, 3, 5, 7].indexOf(m.buttons) > -1, v.right = [2, 3, 6, 7].indexOf(m.buttons) > -1, v.middle = [4, 5, 6, 7].indexOf(m.buttons) > -1, v.wheelDown = e.deltaY > 0, v.wheelUp = e.deltaY < 0;
        break;

      case "touchmove":
      case "touchstart":
        var h = e.touches[0];
        t = h.clientX, o = h.clientY, l = h.screenX, r = h.screenY, i = h.pageX, a = h.pageY;
        break;

      default:
        throw new Error('Unknown event triggered "' + e.type + '"');
    }

    var w = _n({}, d.selectedElement.position),
        E = _n({}, d.selectedElement.boundingRect);

    if (c) {
      var f = c.getBoundingClientRect(),
          p = f.left,
          y = f.top,
          g = f.width,
          L = f.height;
      w.x = t - p - u.x, w.y = o - y - u.y;
      var x = 180 / Math.PI;
      w.angle = Math.atan2(w.y, -w.x) * x + 180, E.left = p, E.top = y, E.width = g, E.height = L;
    }

    s(function (u) {
      return _n(_n({}, u), {
        position: {
          client: {
            x: t,
            y: o
          },
          screen: {
            x: l,
            y: r
          },
          page: {
            x: i,
            y: a
          }
        },
        buttons: v,
        eventType: e.type,
        selectedElement: _n(_n({}, u.selectedElement), {
          position: w,
          boundingRect: E
        })
      });
    });
  },
      v = function v() {
    s(o);
  },
      m = function m() {
    var e = _n({}, d.selectedElement);

    e.isHover = !0, s(function (t) {
      return _n(_n({}, t), {
        selectedElement: e
      });
    });
  },
      h = function h() {
    var e = _n({}, d.selectedElement);

    e.isHover = !1, s(function (t) {
      return _n(_n({}, t), {
        selectedElement: e
      });
    });
  },
      w = function w(e) {
    var t = e.ctrlKey,
        o = e.shiftKey,
        l = e.altKey;
    s(function (e) {
      return _n(_n({}, e), {
        keyboard: {
          ctrl: t,
          shift: o,
          alt: l
        }
      });
    });
  };

  return t(function () {
    if (r) {
      if (!(c = document.getElementById(r))) throw new Error('Element with id="' + r + "\" doesn't exists");
      c.addEventListener("mouseenter", m), c.addEventListener("mouseleave", h);
    }

    return document.addEventListener("mousemove", a), document.addEventListener("mousedown", a), document.addEventListener("mouseup", a), document.addEventListener("wheel", a), document.addEventListener("mouseleave", v), document.addEventListener("keydown", w), document.addEventListener("keyup", w), l && (window.addEventListener("touchmove", a), window.addEventListener("touchstart", a), window.addEventListener("touchend", v)), function () {
      document.removeEventListener("mousemove", a), document.removeEventListener("mousedown", a), document.removeEventListener("mouseup", a), document.removeEventListener("wheel", a), document.removeEventListener("mouseleave", v), document.removeEventListener("keydown", w), document.removeEventListener("keyup", w), l && (window.removeEventListener("touchmove", a), window.removeEventListener("touchstart", a), window.removeEventListener("touchend", v));
    };
  }, []), d;
}